import config from "../config/config.js";
import { getHeaders, handleResponse } from "./utils";

const DocumentService = {
  async getDocument(id) {
    const headers = getHeaders();
    // no-store + cache-bust so a reload (e.g. clicking "Update" inside a loan)
    // always re-fetches from the server. Without this, Chrome could replay a
    // cached response (including a stale 401) on Retry, trapping the LO on the
    // "couldn't open this loan" panel even after the session was fine.
    const response = await fetch(
      config.serviceHost + "document/" + id + "?t=" + Date.now(),
      {
        method: "GET",
        headers,
        cache: "no-store"
      }
    );
    return handleResponse(response);
  },

  async saveDocument(document, metadata, id, name) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("name", name);
    data.append("document", JSON.stringify(document));
    data.append("metadata", JSON.stringify(metadata));
    const response = await fetch(config.serviceHost + `document/${id}`, {
      method: "POST",
      body: data,
      headers
    });
    return handleResponse(response);
  },

  async getPipelineData() {
    const headers = getHeaders();
    const response = await fetch(
      // Cache-bust: the browser was serving a stale pipeline list from its HTTP
      // cache, so a file renamed in the loan tool didn't show the new name until
      // a hard reload (Ctrl+Shift+R). no-store + a timestamp force a fresh fetch
      // every time the LO returns to the pipeline.
      config.serviceHost + "document/pipeline-data?t=" + Date.now(),
      {
        method: "GET",
        headers,
        cache: "no-store"
      }
    );
    return handleResponse(response);
  },

  async createDocument(type, document, metadata, name) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("type", type);
    data.append("name", name);
    data.append("document", JSON.stringify(document));
    data.append("metadata", JSON.stringify(metadata));
    const response = await fetch(config.serviceHost + `document/new`, {
      method: "POST",
      body: data,
      headers
    });
    return handleResponse(response);
  },

  async savePipelineData(pipelineData, id) {
    const headers = getHeaders();
    const data = new FormData();
    data.append("pipeline-data", JSON.stringify(pipelineData));
    const response = await fetch(
      config.serviceHost + `document/${id}/pipeline-data`,
      {
        method: "POST",
        body: data,
        headers
      }
    );
    return handleResponse(response);
  }
};

export default DocumentService;
